import * as React from "react";
import { withRouter } from "react-router";
import { Button, Grid, Loader } from "semantic-ui-react";
import { TagElement, WebComponents } from "@/interfaces";

import { HashTagSet } from "./components/HashTagSet";
import "./styles.scss";
import { HashTagsServices } from "@/services";
import { useAccountSettings, useSocialCoachSession } from "@/utils";

/**
 * Represents Coach Hashtags tab section
 */
const CoachHashtagsTabFC: React.FC = () => {
  const { coachId } = useSocialCoachSession();
  const [updatedHashTagsList, setUpdatedHashTagsList] = React.useState<TagElement[] | undefined>(undefined);
  const [loading, setLoading] = React.useState<boolean>(false);
  const { hasWritePermission } = useAccountSettings();
  const withWritePermission = hasWritePermission(WebComponents.APP_SETTINGS);

  const errorHashTagHandler = (keywords: string[]): void => {
    // setHashtagsListError(() => setErrors(keywords));
  };

  const updateHashtags = (): void => {
    if (updatedHashTagsList) {
      setLoading(true);
      HashTagsServices.updateCoachHashtags(coachId!, {
        hashtags: updatedHashTagsList.map(hashtag => hashtag.displayValue),
        addHashTagAutomatically: false,
      })
        .catch((e: string) => {
          alert(e.substring(0, 40));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Grid columns={16} stretched className={"coachHashtagsTab"} padded>
      {loading ? (
        <Loader active size="large" />
      ) : (
        <>
          <Grid.Row>
            <HashTagSet
              title={"Default Hashtags"}
              coachId={coachId!}
              customTitleClassName={"hashTagSetTitle titleBigSize"}
              customRowClassName={"noPaddingTop"}
              onError={errorHashTagHandler}
              customTagStyle={`background: rgba(61, 174, 245, 0.2);`}
              onSuccess={updatedHashTags => {
                setUpdatedHashTagsList(updatedHashTags);
              }}
            />
          </Grid.Row>
          <Grid.Row>
            {withWritePermission && (
              <Grid.Row>
                <Button onClick={updateHashtags} primary loading={loading} className={"saveHashtagsButton"}>
                  Save
                </Button>
              </Grid.Row>
            )}
          </Grid.Row>
        </>
      )}
    </Grid>
  );
};

export const CoachHashtagsTab = withRouter(CoachHashtagsTabFC);
